var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSc = function SvgSc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M20.1 3.146A11.956 11.956 0 0 0 12 0c-.511 0-1.015.033-1.509.095L4.696 6.782.38 15.005a11.926 11.926 0 0 0 1.255 3.043L12 12l8.1-8.853Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "m21.99 18.648-16.789 3.24A11.943 11.943 0 0 0 12 23.999c4.168 0 7.84-2.125 9.99-5.351Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M20.102 3.148 1.642 18.06a12.048 12.048 0 0 0 1.719 2.268L24 12c0-3.505-1.502-6.658-3.898-8.852Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 12c0 1.038.132 2.046.38 3.006L10.49.094C4.577.836 0 5.884 0 12Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSc;